import { useEffect } from "react";
import { useRecoilState } from "recoil";
import { useLocation } from "react-router-dom";
import { tutorialState } from "../recoil/index";
import { tutorialStepsMap } from "../components/joyride/tutorialSteps";
import { tutorialSeriesMap } from "../components/joyride/tutorialSeriesMap";

export const useTutorial = () => {
  const location = useLocation();
  const [state, setState] = useRecoilState(tutorialState);

  useEffect(() => {
    // console.log("useTutorial state changed:", state);
    // console.log("state", state);
    // console.log("tutorialSeriesMap", tutorialSeriesMap);
  }, [state]);

  useEffect(() => {
    const saved = localStorage.getItem("tutorialProgress");
    if (saved) {
      const { path, stepIndex, series } = JSON.parse(saved);
      if (path === location.pathname) {
        setState({
          isActive: true,
          currentStepIndex: stepIndex,
          currentPage: path,
          series,
        });
      }
    }
  }, [location.pathname]);

  const startTutorial = (path: string, stepIndex = 0, series: string) => {
    setState({
      isActive: true,
      currentStepIndex: stepIndex,
      currentPage: path,
      series: series,
    });
  };

  const saveProgress = (index: number, series: string) => {
    localStorage.setItem(
      "tutorialProgress",
      JSON.stringify({
        series: series,
        path: location.pathname,
        stepIndex: index,
      })
    );
    setState((prev) => ({ ...prev, currentStepIndex: index, series }));
  };

  const saveTourProgress = (index: number) => {
    localStorage.setItem(
      "tutorialProgress",
      JSON.stringify({
        path: location.pathname,
        stepIndex: index,
      })
    );
    setState((prev) => ({ ...prev, currentStepIndex: index }));
  };

  const saveTutorialProgress = (index: number) => {
    localStorage.setItem(
      "tutorialProgress",
      JSON.stringify({
        path: location.pathname,
        stepIndex: index,
        type: "tutorial",
      })
    );
    setState((prev) => ({ ...prev, currentStepIndex: index }));
  };

  const stopTutorial = () => {
    setState({
      isActive: false,
      currentStepIndex: 0,
      currentPage: "",
      series: "",
    });
  };

  const resetTutorial = () => {
    localStorage.removeItem("tutorialProgress");
    setState({
      isActive: false,
      currentStepIndex: 0,
      currentPage: "",
      series: "",
    });
  };

  const getNextPath = () => {
    const current = state.currentPage;
    const series = state.series || "basic";
    return tutorialSeriesMap[series]?.flow?.[current] || null;
  };

  // console.log("useTutorial steps:", tutorialStepsMap[state.currentPage]);

  return {
    // steps: tutorialStepsMap[state.currentPage] || [],
    steps: tutorialSeriesMap[state.series]?.steps?.[state.currentPage] || [],
    currentStepIndex: state.currentStepIndex,
    isActive: state.isActive,
    saveProgress,
    saveTourProgress,
    saveTutorialProgress,
    stopTutorial,
    startTutorial,
    getNextPath,
    resetTutorial,
  };
};
